// @ts-nocheck
import { Skeleton } from '@mui/material';
import { Box } from '@mui/system';

import TableSkeleton from './TableSkeleton';

const AssociationFieldTableViewComponentSkeleton = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
    }}
  >
    {/* Search + subtabs + dropdown row */}
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'space-between',
        borderRadius: '4px',
        gap: 2,
        minHeight: '200px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        <Skeleton
          variant="rounded"
          width={240}
          height={36}
          sx={{ borderRadius: '8px' }}
        />

        <Skeleton
          key="subtabs"
          variant="rounded"
          width={210}
          height={36}
          sx={{ borderRadius: '8px' }}
        />
      </Box>

      <TableSkeleton columns={6} rows={6} />
    </Box>
  </Box>
);

export default AssociationFieldTableViewComponentSkeleton;
